import React, { useState, useEffect } from "react";
import './DisclaimerPopup.css'; // Create this CSS file for styling
import { translations } from '../../utils/translations';

const DisclaimerPopup = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const LANG_MAP = { pt: "portuguese", en: "english", es: "spanish" };
    const [selectedLanguage, setSelectedLanguage] = useState("pt");
    const t = translations[LANG_MAP[selectedLanguage] || selectedLanguage] || translations['portuguese'];

    useEffect(() => {        
        const savedLang = localStorage.getItem("preferredLanguage");
        if (savedLang) {
            setSelectedLanguage(savedLang);
        } else {
            const browserLang = navigator.language || navigator.userLanguage;
            let defaultLang = "pt";

            if (browserLang.startsWith("pt")) {
                defaultLang = "pt";
            } else if (browserLang.startsWith("es")) {
                defaultLang = "es";
            } else if (browserLang.startsWith("en")) {
                defaultLang = "en";
            }
            setSelectedLanguage(defaultLang);
            localStorage.setItem("preferredLanguage", defaultLang);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        onClose(); // Notify parent component
    };

    if (!isVisible) return null;

    return (
        <div className="disclaimer-popup">
            <div className="disclaimer-content">
                <span className="chatbox-title">{t.disclaimerTitle}</span>
                <div className="chatbox-subtitle" style={{ whiteSpace: "pre-line" }}>
                    {t.disclaimer}{" "}
                    <a
                        href={t.disclaimerLinkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t.disclaimerLinkText}
                    </a>
                </div>
                <button onClick={handleClose}>{t.agreement}</button>
            </div>
        </div>
    );
};

export default DisclaimerPopup;